import config from '../config';
import yaml from 'yaml';

export type DynamicConfig = {
  ENABLED_STATES: string;
  DISABLED_VENUES?: string;
  OVERRIDE_LOCATION?: string;
  SPORTSBOOK_BASE_URL: string;
  MOBILE_STATES: string;
  MOBILE_QUERY_PARAMS?: string;
  BET_AHEAD_BASE_URL: string;
  BET_AHEAD_STATES: string;
};

const ExpectedConfigKeys: Array<keyof DynamicConfig> = [
  'ENABLED_STATES',
  'DISABLED_VENUES',
  'OVERRIDE_LOCATION',
  'SPORTSBOOK_BASE_URL',
  'MOBILE_STATES',
  'MOBILE_QUERY_PARAMS',
  'BET_AHEAD_BASE_URL',
  'BET_AHEAD_STATES'
];

export function parseDynamicConfig(configFile: string): DynamicConfig | undefined {
  const parsedYaml = yaml.parse(configFile);

  let parsedConfig: Partial<DynamicConfig> = { ...parseLevel(parsedYaml) };

  const regionLevel = parsedYaml[config.REGION];
  if (regionLevel) {
    parsedConfig = { ...parsedConfig, ...parseLevel(regionLevel) };
  }

  const stateLevel = (regionLevel ?? {})[config.STATE];
  if (stateLevel) {
    parsedConfig = { ...parsedConfig, ...parseLevel(stateLevel) };
  }

  return parsedConfig['ENABLED_STATES'] === undefined ? undefined : (parsedConfig as DynamicConfig);
}

function parseLevel(config: any): Partial<DynamicConfig> {
  const result: Partial<DynamicConfig> = {};
  for (const key of ExpectedConfigKeys) {
    if (typeof config[key] === 'string') {
      result[key] = config[key];
    }
  }
  return result;
}
